import BaseRequest from './index';

class ReferralService extends BaseRequest {
  constructor() {
    super();
    this.bindMethods();
  }

  bindMethods() {
    this.getMyReferrals = this.getMyReferrals.bind(this);
    this.getReferralCode = this.getReferralCode.bind(this);
  }

  async getMyReferrals<T>(): Promise<T> {
    return await this.api.get('/user/referral');
  }

  async getReferralCode<T>(): Promise<T> {
    return await this.api.get('/user/referral/code');
  }
}

const referralService = new ReferralService();

export default referralService;
